import { Button, Checkbox, DataSource, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutUserGroup extends Layout {
    buttonAddAll: Button;
    buttonAddSelected: Button;
    buttonRemoveAll: Button;
    buttonRemoveSelected: Button;
    checkboxAllUsers: Checkbox;
    labelUsersInGroup: Label;
    labelUsersNotInGroup: Label;
    panelActionButtons: Panel;
    panelBottomVertSpacer: Panel;
    panelMembership: Panel;
    panelTopVertSpacer: Panel;
    panelUserGroup: Panel;
    panelUsersInGroup: Panel;
    panelUsersNotInGroup: Panel;
    sourceUserGroupList: DataSource;
    sourceUsersInGroup: DataSource;
    sourceUsersNotInGroup: DataSource;
    tableUsersInGroup: Table;
    tableUsersNotInGroup: Table;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxUserGroupType: Textbox;
    textboxUserType: Textbox;
}
